export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Total estimé',
        merchandiseSubtotal: 'Sous-total des marchandises',
        giftCardShipping: 'Expédition de la carte-cadeau',
        merchandiseShipping: 'Expédition de la marchandise',
        shippingAndHandling: 'Expédition et manutention',
        discounts: 'Réductions',
        gstHst: 'TPS/TVH estimées',
        pst: 'TVP estimée',
        tax: 'Taxes estimées',
        andOtherFees: 'et autres frais',
        storeCreditRedeemed: 'Crédit au compte',
        giftCardRedeemed: 'Carte-cadeau échangée',
        eGiftCardRedeemed: 'Carte-cadeau électronique utilisée',
        creditCardPayment: 'Paiement par carte de crédit',
        payPalPayment: 'Paiement PayPal',
        bopisIncreasedAuthorizationWarning: `{*}Estimated total is based on first-choice items. *Your payment method will be temporarily authorized for ${vars[0]}*, to cover potential item substitutions. You will only be charged for the items you receive. The transaction will be finalized when you pick up the order. Promotions may be removed if item substitutions occur. Your final total will be displayed in your email receipt and Order History. The temporary authorization will be removed by your financial institution 3-5 days after you receive your items. Please contact your financial institution for questions related to temporary authorizations.`,
        sddIncreasedAuthorizationWarning: `{*}Estimated total is based on first-choice items. *Your payment method will be temporarily authorized for ${vars[0]}*, to cover potential item substitutions. You will only be charged for the items you receive. The transaction will be finalized when your order is delivered. Promotions may be removed if item substitutions occur. Your final total will be displayed in your email receipt and Order History. The temporary authorization will be removed by your financial institution 3-5 days after you receive your items. Please contact your financial institution for questions related to temporary authorizations.`,
        submitEdits: 'Soumettre les modifications',
        subscribe: 'S’abonner',
        placeOrder: 'Passer commande',
        shippingHandling: 'Expédition et manutention',
        pickupText: 'Ramassage',
        free: 'GRATUIT',
        shippingHandlingInfo: 'Renseignements sur l’expédition et la manutention',
        salesTax: 'Taxe de vente',
        pointsUsed: 'Utilisé',
        bagFee: 'Frais de sac',
        specialFee: 'Frais spéciaux',
        pointsAfterPickup: 'Vous accumulerez des points Beauty Insider pour cet achat après avoir ramassé votre commande.',
        gotIt: 'Compris',
        autoReplenishmentSavings: 'Économies sur le réapprovisionnement automatique',
        youSave: 'Vous économisez',
        sduSavingsUS: '6,95 $',
        sduSavingsCA: '9,95 $',
        withSDUUnlimited: 'avec la livraison le jour même illimitée'
    };

    return resources[label] || label;
}
